import React, {useState, useEffect} from 'react';
import {Modal, Text, TextInput, Button} from '@/ui-kits';

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: {name: string}) => void;
}

export const AddCategoryModal: React.FC<AddCategoryModalProps> = ({
  open,
  onClose,
  onSave,
}) => {
  const [categoryName, setCategoryName] = useState('');

  useEffect(() => {
    if (open) {
      // Reset form when modal opens
      setCategoryName('');
    }
  }, [open]);

  const isDirty = Boolean(categoryName.trim());
  const closeModal = () => {
    if (!isDirty) onClose();
  };

  const handleSave = () => {
    if (!categoryName.trim()) return;
    
    onSave({
      name: categoryName.trim(),
    });
    
    // Reset form
    setCategoryName('');
    onClose();
  };

  const isFormValid = categoryName.trim().length > 0;

  return (
    <Modal
      open={open}
      onClose={closeModal}
      className="relative bg-white py-6 px-8 rounded-xl gap-4 w-[90vw] max-w-[500px]">
      <Text variant="free" className="text-ui_blue font-FigtreeBold text-3xl mb-4">
        Add Category
      </Text>

      <div className="flex flex-col gap-4">
        {/* Category Name */}
        <TextInput
          label="Category Name"
          value={categoryName}
          onChangeText={(value) => setCategoryName(value)}
          placeholder="Enter Category Name"
          className="w-full"
          wrapperClassName="!border-ui_placeholder"
          required
        />
      </div>

      {/* Action Buttons */}
      <div className="flex gap-4 mt-6">
        <Button
          variant="secondary"
          title="Cancel"
          onClick={onClose}
          className="flex-1"
        />
        <Button
          variant="primary"
          title="Save"
          onClick={handleSave}
          disabled={!isFormValid}
          className="flex-1"
        />
      </div>
    </Modal>
  );
};

